import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/BlackProfile.css";
import ApiService from "../nhrc_apis/ApiService";

function BlackProfile() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlackProfiles();
  }, []);

  const fetchBlackProfiles = async () => {
    try {
      setLoading(true);
      const response = await ApiService.BlackProfilesAPI.getAllBlackProfiles();
      console.log("GET BLACK PROFILES RESPONSE:", response.data);
      setData(response.data || []);
    } catch (error) {
      console.error("ERROR FETCHING BLACK PROFILES:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (employee) => {
    navigate("/dashboard/AdminBlackProfileView", {
      state: { employee },
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Do you want to delete this profile?")) {
      try {
        await ApiService.BlackProfilesAPI.deleteBlackProfile(id);
        const updated = data.filter((item) => item.id !== id);
        setData(updated);
        alert("Deleted successfully!");
      } catch (error) {
        console.error("DELETE ERROR:", error);
        alert("Delete failed!");
      }
    }
  };

  const getEmployeeName = (emp) => emp.employee_name || emp.name || "N/A";
  const getDesignation = (emp) => emp.designation || "N/A";

  return (
    <div className="nhrc-bp-page">
      <div className="nhrc-bp-main-content">
        <div className="nhrc-bp-wrapper">
          <div className="nhrc-bp-card">

            <div className="nhrc-bp-header">
              <span>Employee Black Profile</span>
              <button
                className="nhrc-bp-add-btn"
                onClick={() => navigate("/dashboard/Addblockprofile")}
              >
                + Add Profile
              </button>
            </div>

            <div className="nhrc-bp-table-wrap">
              {loading ? (
                <h3 style={{ textAlign: "center", padding: "20px" }}>Loading...</h3>
              ) : data.length === 0 ? (
                <h3 style={{ textAlign: "center", padding: "20px" }}>
                  No blacklisted profiles found
                </h3>
              ) : (
                <table className="nhrc-bp-table">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>Employee Name</th>
                      <th>Job Role</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((emp, index) => (
                      <tr key={emp.id || index}>
                        <td style={{ textAlign: "left" }}>
                          {index + 1}. {getEmployeeName(emp)}
                        </td>
                        <td>{getDesignation(emp)}</td>
                        <td>
                          <button
                            className="nhrc-bp-btn nhrc-bp-btn-view"
                            onClick={() => handleView(emp)}
                          >
                            View
                          </button>
                          <button
                            className="nhrc-bp-btn nhrc-bp-btn-delete"
                            onClick={() => handleDelete(emp.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default BlackProfile;